// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","logoImg":"Header_logoImg__sg0Tc","nav":"Header_nav__ZwnMZ"};